import { AWSUrls } from './aws.urls';

// BACKEND_TYPES is objects containing different backend based urls. Backend type is specified in vendor object.
export const BACKEND_TYPES = {
    AWS: AWSUrls,
};
